import type { Activity, Customer, ProductPlan, Ticket, TicketCategory, TicketPriority, TicketScope, TicketStatus, View } from "./types";

export const productPlans: ProductPlan[] = [];

export const customers: Customer[] = [];

export const tickets: Ticket[] = [];

export const ticketCategories: TicketCategory[] = [];

export const activities: Activity[] = [];

export const weeklyVolume = [0, 0, 0, 0, 0, 0, 0];
export const weekLabels = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
export const currentUser = "System";
export const supportAgents: string[] = [];
export const ticketPriorities: TicketPriority[] = ["High", "Medium", "Low"];
export const ticketStatuses: TicketStatus[] = ["Open", "In Progress", "Waiting customer", "Pending", "Resolved"];
export const ticketTabs: TicketScope[] = ["All Tickets", "Assigned to Me", "Unassigned"];
export const navItems: View[] = ["Dashboard", "Tickets", "Calendar", "Customers", "Knowledge Base", "Items", "Vendors", "Expenses", "Reporting", "Users", "Logs", "Archive", "Settings", "Notifications"];
export const fallbackCustomer = customers[0];
export const fallbackTicket = tickets[0];
export const viewPaths: Record<View, string> = {
  Dashboard: "/dashboard",
  Calendar: "/calendar",
  Tickets: "/tickets",
  Customers: "/customers",
  Items: "/items",
  Vendors: "/vendors",
  Expenses: "/expenses",
  Logs: "/logs",
  Archive: "/archive",
  Users: "/users",
  Notifications: "/notifications",
  "Knowledge Base": "/knowledge-base",
  Reporting: "/reporting",
  Settings: "/settings",
};
export const knowledgeBaseNewArticlePath = `${viewPaths["Knowledge Base"]}/new`;
export const knowledgeBaseCollectionsPath = `${viewPaths["Knowledge Base"]}/collections`;
export const knowledgeBaseArticlesPath = `${viewPaths["Knowledge Base"]}/articles`;

export type SettingsSection = "workspace" | "ticketing" | "security";

export const settingsSectionPaths: Record<SettingsSection, string> = {
  workspace: `${viewPaths.Settings}/workspace`,
  ticketing: `${viewPaths.Settings}/ticketing`,
  security: `${viewPaths.Settings}/security`,
};

export const settingsSectionOrder: SettingsSection[] = ["workspace", "ticketing", "security"];

export function getKnowledgeBaseCollectionPath(collectionId: string) {
  return `${knowledgeBaseCollectionsPath}/${encodeURIComponent(collectionId)}`;
}

export function getKnowledgeBaseArticlePath(articleId: string) {
  return `${knowledgeBaseArticlesPath}/${encodeURIComponent(articleId)}`;
}

export function getKnowledgeBaseArticleEditPath(articleId: string) {
  return `${getKnowledgeBaseArticlePath(articleId)}/edit`;
}

export const priorityClasses: Record<TicketPriority, string> = {
  High: "bg-[#ffdad6] text-[#93000a]",
  Medium: "bg-[#dae5df] text-[#3f4945]",
  Low: "bg-[#88f8c5] text-[#002114]",
};

export const statusClasses: Record<TicketStatus, string> = {
  "In Progress": "text-[#006949]",
  "Waiting customer": "text-[#b54708]",
  Pending: "text-[#98a2b3]",
  Resolved: "text-[#006949]",
  Open: "text-[#9a3f3b]",
};

export const healthClasses: Record<Customer["health"], string> = {
  Healthy: "bg-[#dcfce7] text-[#166534]",
  Watch: "bg-[#fef3c7] text-[#92400e]",
  Escalated: "bg-[#fee2e2] text-[#991b1b]",
  Disabled: "bg-[#f2f4f7] text-[#475467]",
};

export const accountStatusClasses: Record<Customer["accountStatus"], string> = {
  Active: "bg-[#ecfdf3] text-[#027a48]",
  Disabled: "bg-[#f2f4f7] text-[#475467]",
};

export const activityToneClasses: Record<Activity["tone"], string> = {
  primary: "bg-[rgba(0,133,93,0.14)] text-[#006949]",
  neutral: "bg-[#e5e7eb] text-[#475467]",
  success: "bg-[#dcfce7] text-[#166534]",
};
